import Command from '../Command';
import { readInt64, writeInt64, readInt32, writeInt32 } from '../StreamUtil';

class StartStreamingCommand extends Command {
	constructor(sender, recipient, externalId, seconds) {
		super(Command.START_STREAMING, sender, recipient);
		this.externalId = externalId;
		this.seconds = seconds;
	}

	read(input) {
		super.read(input);
		this.externalId = readInt64(input);
		this.seconds = readInt32(input);
	}

	write(output) {
		super.write(output);
		writeInt64(output, this.externalId);
		writeInt32(output, this.seconds);
	}
}

export default StartStreamingCommand;
